// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { HolderService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { ERR_TER_HOLDER_SVC, SUC_TER_HOLDER_SVC } from '../../../../utils/strings';

export const useTerminateHolderService = () => {
  const { submit } = useExerciseSubmission(
    HolderService.HolderService_Terminate,
    SUC_TER_HOLDER_SVC,
    ERR_TER_HOLDER_SVC,
  );
  return submit;
};
